module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-sample",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', [_c('div', [_c('el-select', {
    attrs: {
      "placeholder": "请选择图标类型"
    },
    on: {
      "change": _vm.sampleChange
    },
    model: {
      value: (_vm.sampletype),
      callback: function($$v) {
        _vm.sampletype = $$v
      },
      expression: "sampletype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "1、年度预算分配、年度预算计划",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "2、预算计划与执行进度",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "3、预算计划与执行季度趋势",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "4、预算计划与执行月度趋势",
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "5、策略计划占比",
      "value": "5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "6、策略执行进度、会议执行进度",
      "value": "6"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "7、策略月度趋势",
      "value": "7"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "8、会议计划占比",
      "value": "8"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "9、评分",
      "value": "9"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 30,
      "placeholder": "选择图标类型后，会在这里显示对应的数据，修改数据后点击应用可以实时更新图表"
    },
    model: {
      value: (_vm.sampledata),
      callback: function($$v) {
        _vm.sampledata = $$v
      },
      expression: "sampledata"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.setSample
    }
  }, [_vm._v("应用")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample1",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": ['已分配预算'],
      "dataset-source": _vm.data1,
      "option": _vm.option1
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample2",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": ['进度', '已计划预算', '已执行预算', '待执行预算', '计划外预算'],
      "dataset-source": _vm.data2,
      "option": _vm.option2
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample3",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": ['季度', '已计划', '已执行', '待执行', '计划外', '已分配预算'],
      "dataset-source": _vm.data3,
      "option": _vm.option3
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample4",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": ['月度', '已计划', '已执行', '待执行', '计划外'],
      "dataset-source": _vm.data4,
      "option": _vm.option4
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample5",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": ['策略名', '占比'],
      "dataset-source": _vm.data5,
      "option": _vm.option5
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample6",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": ['策略名', '已执行', '待执行', '计划外', '已计划'],
      "dataset-source": _vm.data6,
      "option": _vm.option6
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample7",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": _vm.dimensions7,
      "dataset-source": _vm.source7,
      "option": _vm.option7
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample8",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": ['类型', '占比'],
      "dataset-source": _vm.data8,
      "option": _vm.option8
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample9",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": ['预算', '评分'],
      "dataset-source": _vm.data9,
      "option": _vm.option9
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1375c92a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1375c92a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/dashboard/sample/index.vue
// module id = 1551
// module chunks = 7